var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { dia } from '@joint/plus';
var Container = /** @class */ (function (_super) {
    __extends(Container, _super);
    function Container() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.markup = [{
                tagName: 'rect',
                selector: 'body'
            }, {
                tagName: 'text',
                selector: 'label'
            }, {
                tagName: 'path',
                selector: 'grid',
                attributes: {
                    'stroke': 'white',
                    'stroke-opacity': 0.05,
                    'fill': 'none'
                }
            }];
        return _this;
    }
    Container.prototype.defaults = function () {
        return __assign(__assign({}, _super.prototype.defaults), { type: 'app.Container', z: 1, attrs: {
                body: {
                    width: 'calc(w)',
                    height: 'calc(h)',
                    cursor: 'default'
                },
                label: {
                    fontFamily: 'sans-serif',
                    textVerticalAnchor: 'middle',
                    textAnchor: 'middle',
                    x: 'calc(0.5 * w)',
                    y: 25,
                    fontSize: 16,
                    fontWeight: 700,
                    fill: '#FFFFFF',
                    style: { textTransform: 'uppercase' },
                    pointerEvents: 'none'
                }
            } });
    };
    Container.isContainer = function (el) {
        return el.get('type') === 'app.Container';
    };
    return Container;
}(dia.Element));
export { Container };
var Child = /** @class */ (function (_super) {
    __extends(Child, _super);
    function Child() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.markup = [{
                tagName: 'rect',
                selector: 'body',
            }, {
                tagName: 'text',
                selector: 'label'
            }];
        return _this;
    }
    Child.prototype.defaults = function () {
        return __assign(__assign({}, _super.prototype.defaults), { type: 'app.Child', z: 2, attrs: {
                body: {
                    width: 'calc(w)',
                    height: 'calc(h)',
                    fill: '#FFFFFF',
                    stroke: 'none',
                    strokeWidth: 2
                },
                label: {
                    textVerticalAnchor: 'middle',
                    textAnchor: 'middle',
                    x: 'calc(0.5 * w)',
                    y: 'calc(0.5 * h)',
                    fontFamily: 'sans-serif',
                    fontSize: 16,
                    fontWeight: 700,
                    fill: '#FFFFFF',
                    style: { textTransform: 'uppercase' }
                }
            } });
    };
    return Child;
}(dia.Element));
export { Child };
var Link = /** @class */ (function (_super) {
    __extends(Link, _super);
    function Link() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.markup = [{
                tagName: 'path',
                selector: 'line'
            }];
        return _this;
    }
    Link.prototype.defaults = function () {
        return __assign(__assign({}, _super.prototype.defaults), { type: 'Link', z: -1, attrs: {
                root: {
                    cursor: 'pointer'
                },
                line: {
                    fill: 'none',
                    connection: true,
                    stroke: '#A0A0A0',
                    strokeWidth: 1.5
                }
            } });
    };
    return Link;
}(dia.Link));
export { Link };
